import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { UserModel } from './user.model';

export class TodoModel extends BaseModel implements Deserializable {

  // columns
  name: { [key: string]: string } = {};
  onsite?: boolean;
  virtual?: boolean;

  // ac only
  completed?: boolean;
  completed_at?: string;
  completed_by?: any;

}
